const TOP_GAME_MEDALS = ['🥇', '🥈', '🥉'] as const;
const TOP_GAME_BORDER_CLASS_NAMES = [
  'border-2 border-[#D4AF37] hover:border-[#D4AF37]',
  'border-2 border-[#A8A9AD] hover:border-[#A8A9AD]',
  'border-2 border-[#CD7F32] hover:border-[#CD7F32]',
] as const;

export const getTopGameMedal = (rank?: number) => {
  if (rank == null) {
    return null;
  }

  return TOP_GAME_MEDALS[rank - 1] ?? null;
};

export const getTopGameBorderClassName = (rank?: number) => {
  if (rank == null) {
    return null;
  }

  return TOP_GAME_BORDER_CLASS_NAMES[rank - 1] ?? null;
};
